import { C } from "../tokens";

interface Props {
  value: number; // 0..100
  color?: string;
  height?: number;
  label?: string;
}

export function ProgressBar({ value, color = C.blue, height = 6, label }: Props) {
  const v = Math.max(0, Math.min(100, value));
  return (
    <div style={{ width: "100%" }}>
      {label && (
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: C.textMuted, marginBottom: 4 }}>
          <span>{label}</span>
          <span style={{ color, fontWeight: 700 }}>{v.toFixed(0)}%</span>
        </div>
      )}
      <div
        style={{
          width: "100%",
          height,
          background: C.surfaceMid,
          borderRadius: height,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${v}%`,
            height: "100%",
            background: `linear-gradient(90deg, ${color}, ${color}cc)`,
            boxShadow: `0 0 12px ${color}77`,
            transition: "width 0.4s ease",
          }}
        />
      </div>
    </div>
  );
}
